<template>
    <div class="preloader-wrapper active" :class="size">
        <div class="spinner-layer spinner-white-only">
            <div class="circle-clipper left">
                <div class="circle"></div>
            </div><div class="gap-patch">
                <div class="circle"></div>
            </div><div class="circle-clipper right">
                <div class="circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    size: { type: String, required: false, default: () => 'small' }
  }
}
</script>

<style scoped>
    .preloader-wrapper { vertical-align: middle ;}
    .preloader-wrapper.x-small {
        width: 20px;
        height: 20px;
    }

    .spinner-white, .spinner-white-only {
        border-color: #FFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/POSSSpinner.vue